export const getFilterFormFields = (filterItems) => {
    const { allActiveBu, allActiveYear, vendorTypes } = filterItems;
    return [
        {
            label: 'BU',
            type: 'select',
            items: allActiveBu,
            formKey: 'businessAreaIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select branch",
            disabled: false,
            isShowCount: true
        },
        {
            label: 'Year',
            type: 'select',
            items: allActiveYear,
            formKey: 'yearIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Year",
            disabled: false,
            isShowCount: true
        },
        {
            label: 'Vendor Type',
            type: 'select',
            items: vendorTypes,
            formKey: 'vendorTypes',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Vendor Type",
            disabled: false,
            isShowCount: true
        },
    ]
}